import { createApp } from 'vue';
import Carousel from '@website/components/Carousel.vue';
import ContactForm from '@website/components/ContactForm.vue';
import Dropdown from '@website/components/Dropdown.vue';
import LikeButton from '@website/components/LikeButton.vue';
import TourRequestForm from '@website/components/TourRequestForm.vue';
import InputMask from '@website/components/InputMask.vue';
import Range from '@website/components/Range.vue';
import SignaturePadComponent from '@website/components/SignaturePad.vue';
import MediaViewer from '@website/components/MediaViewer.vue';
import PropertyMap from '@website/components/PropertyMap.vue';
import PropertiesMap from '@website/components/PropertiesMap.vue';

// ---------------------------------------------------------------------------
// Vue islands — loader
// ---------------------------------------------------------------------------

const vueComponents = {
  // Fase 4
  Carousel,
  Dropdown,
  LikeButton,
  // Fase 5
  ContactForm,
  TourRequestForm,
  // Fase 6
  InputMask,
  Range,
  SignaturePad: SignaturePadComponent,
  MediaViewer,
  PropertyMap,
  PropertiesMap,
};

document.querySelectorAll('[data-vue-component]').forEach((el) => {
  const name = el.dataset.vueComponent;

  let props = {};
  try {
    props = JSON.parse(el.dataset.props || '{}');
  } catch {
    console.error(`[Vue islands] JSON inválido en data-props de "${name}"`);
    return;
  }

  const Component = vueComponents[name];

  if (!Component) {
    console.warn(`[Vue islands] Componente no registrado: "${name}"`);
    return;
  }

  createApp(Component, props).mount(el);
});
